/** @jsx jsx */

import React, { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';

const Feedback = props => {
  const { useMediaInFeedback = true, onClose, children } = props;
  let [img, txt, btn] = children;

  const isImg = img.props.child === 1;

  return (
    <Modal onClose={() => onClose()}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          max-width: 768px;
          padding: 50px;
        `}
      >
        {useMediaInFeedback && (
          <div
            css={css`
            width: 75%;

            margin-bottom: 30px;

            ${isImg &&
              `
              position: relative;
              min-height: 30vh;

            `}

            img {
              max-height: 30vh !important;
            }

            @media (max-width: 768px) {
              width: 100%;
              margin-bottom: 25px;
            }
          `}
          >
            {img}
          </div>
        )}

        <div
          css={css`
            width: 100%;
            margin-bottom: 30px;
          `}
        >
          {txt}
        </div>
        <div
          css={css`
            display: flex;
            justify-self: flex-end;
            justify-content: center;
            width: 100%;
          `}
        >
          {window.dev() ? btn : React.cloneElement(btn, { onClick: onClose })}
          {/* {React.cloneElement(btn, { onClick: onClose })} */}
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
